// 사용자 정보 조회를 위한 URL을 생성하는 함수
const getUserUrl = (base: string, cursor?: number) => {
  const urlSearchParams = new URLSearchParams();
  if (cursor !== undefined) {
    urlSearchParams.append('cursor', String(cursor));
  }
  return `${base}?${urlSearchParams.toString()}`;
};

export const END_POINT = {
  // 메뉴
  menuController: {
    main: '/menus', // 메뉴 엔드포인트의 기본 경로
    /** POST **/
    postMenus: () => END_POINT.menuController.main, // 메뉴 생성을 위한 엔드포인트
    /** GET **/
    getMenus: () => END_POINT.menuController.main, // 메뉴 전체 조회
    /** DELETE **/
    deleteMenus: (menuId: string) => `${END_POINT.menuController.main}/${menuId}`, // 메뉴 삭제 (menuId에 따른 메뉴 삭제)
    /** PUT **/
    putMenus: (menuId: string) => `${END_POINT.menuController.main}/${menuId}`, // 메뉴 수정 (menuId에 따른 메뉴 수정)
    /** PATCH **/
    patchMenus: (menuId: string) => `${END_POINT.menuController.main}/${menuId}/parent` // 상위 메뉴 수정 (menuId에 따른 메뉴 수정)
  },
  // 코드인증
  verifyController: {
    main: '/verify', // 메뉴 엔드포인트의 기본 경로
    /** POST **/
    postEmail: () => `${END_POINT.verifyController.main}/email`, // 이메일 인증코드 전송
    postEmailConfirm: () => `${END_POINT.verifyController.main}/email/confirm`, // 이메일에 전송된 인증코드 확인
    postPassword: () => `${END_POINT.verifyController.main}/forgot-password`, // 비밀번호 재설정 인증 요청
    postPasswordConfirm: () => `${END_POINT.verifyController.main}/forgot-password/confirm`, // 비밀번호 재설정 인증 확인
    postPhone: () => `${END_POINT.verifyController.main}/phone`, // 휴대전화 인증 요청
    postPhoneConfirm: () => `${END_POINT.verifyController.main}/phone/confirm`, // 대전화 인증 확인
    /** PUT **/
    putPasswordChange: () => `${END_POINT.verifyController.main}/forgot-password/change` // 비밀번호 변경
  },
  // 인증
  authController: {
    getCheckUsername: '/check-username', // 아이디 중복 확인
    postFindUsername: '/find-username', //아이디찾기
    postLogin: '/login', // 로그인
    getMe: '/me', // 내 정보(로그인 한 사용자) 조회

    postSignup: '/signup', // 회원가입
    postTokenRefresh: '/token/refresh', // 토큰 갱신을 위한 POST 요청

    putUserIdAbort: (userId: number) => `/users/${userId}/abort`, // 사용자 정지
    putUserIdActive: (userId: number) => `/users/${userId}/active`, // 사용자 활성화

    putUserNameInitPassword: (userName: string) => `/users/${userName}/init-password`, // 사용자 비밀번호 초기화
    deleteWithdraw: '/withdraw' //회원탈퇴
  },
  // 디지털 기기
  digitalDevicesController: {
    digitalDevices: '/digital-devices',
    /** GET **/
    getDigitalDevices: () => `${END_POINT.digitalDevicesController.digitalDevices}`, // 디지털기기 가져오기
    /** POST **/
    postDigitalDevices: () => `${END_POINT.digitalDevicesController.digitalDevices}`, // 디지털기기 추가
    /** PUT **/
    putDigitalDevices: (itemId: number) => `${END_POINT.digitalDevicesController.digitalDevices}/${itemId}`, // 디지털기기 변경
    /** DELETE **/
    deleteDigitalDevices: (itemId: number) => `${END_POINT.digitalDevicesController.digitalDevices}/${itemId}` // 디지털기기 삭제
  },
  // 사업장
  businessPlacesController: {
    businessPlaces: '/business-places',
    /** GET **/
    getBusinessPlaces: () => `${END_POINT.businessPlacesController.businessPlaces}`, // 모든 사업장 정보 가져오기
    /** POST **/
    postBusinessPlaces: () => `${END_POINT.businessPlacesController.businessPlaces}`, // 사업장 추가
    /** PUT **/
    putBusinessPlaces: (itemId: number) => `${END_POINT.businessPlacesController.businessPlaces}/${itemId}`, // 사업장 변경
    /** DELETE **/
    deleteBusinessPlaces: (itemId: number) => `${END_POINT.businessPlacesController.businessPlaces}/${itemId}` // 사업장 삭제
  },

  // 파일
  fileController: {
    main: '/files', // 파일 엔드포인트의 기본 경로
    getDownload: (fileName: string) => `${END_POINT.fileController.main}/download?file=${fileName}` // 파일 다운로드
  },

  // 매뉴얼
  manualController: {
    main: '/manual', // 매뉴얼 엔드포인트의 기본 경로
    getManual: () => `${END_POINT.manualController.main}` // 매뉴얼 다운로드
  },
  // FAQ
  faqController: {
    main: '/faq', // FAQ 엔드포인트의 기본 경로
    getFaq: () => `${END_POINT.faqController.main}` // FAQ 다운로드
  },

  // 이메일 템플릿
  emailTemplateController: {
    main: '/email-templates', // 이메일 템플릿 엔드포인트의 기본 경로
    /** POST **/
    postEmailTemplate: () => `${END_POINT.emailTemplateController.main}`, // 이메일 템플릿 저장
    postEmailTemplateTest: (type: string, language: string) => `${END_POINT.emailTemplateController.main}/test?type=${type}&language=${language}` // 이메일 템플릿 테스트
  },

  // 약관동의
  policyController: {
    main: '/policies', // 약관동의 엔드포인트의 기본 경로
    /** POST **/
    postPrivacy: () => `${END_POINT.policyController.main}/privacy`, // 개인정보처리방침 저장, 수정
    postTerms: () => `${END_POINT.policyController.main}/terms`, // 이용약관 저장, 수정
    postSecurity: () => `${END_POINT.policyController.main}/security`, // 보안서약서조회 저장, 수정
    /** GET **/
    getPolicies: () => END_POINT.policyController.main, // 약관동의조회
    getSecurity: () => `${END_POINT.policyController.main}/security`, // 보안서약서조회
    getTerms: () => `${END_POINT.policyController.main}/terms`, // 모든 이용약관 불러오기
    getPrivacy: (date?: string) => `${END_POINT.policyController.main}/privacy${date ? `?date=${date}` : ''}` // 모든 개인정보처리방침 불러오기
  },
  // 환경설정
  settingController: {
    main: '/settings', // 환경설정 엔드포인트의 기본 경로
    /** GET **/
    getSelectItems: () => `${END_POINT.settingController.main}/select-items`, // 항목관리 조회
    getSystem: () => `${END_POINT.settingController.main}/system`, // 시스템설정 조회
    postUploadManual: (language: string) => `${END_POINT.settingController.main}/system/manual/${language}`, // 시스템설정 조회
    postUploadFaq: (language: string) => `${END_POINT.settingController.main}/system/faq/${language}`, // 시스템설정 조회
    putUpdateRemindTime: () => `${END_POINT.settingController.main}/system/remind-time`, // 리마인드 시간 변경
    getPolicies: () => `${END_POINT.settingController.main}/policies`, // 시스템설정 조회

    users: '/settings/users',
    getUsers: () => `${END_POINT.settingController.users}`, // 사용자관리
    getEmployees: () => `${END_POINT.settingController.users}/employees`, // 임직원사용자 조회
    getVisitors: () => `${END_POINT.settingController.users}/visitors`, // 외부사용자 조회
    putVisitorsNotification: () => `${END_POINT.settingController.users}/visitor-notification`, // 외부사용자 알림 변경
    getEmployeesId: (id: number) => `${END_POINT.settingController.users}/employees/${id}`, // 임직원사용자 단건 조회
    getVisitorsId: (id: number) => `${END_POINT.settingController.users}/visitors/${id}`, // 외부사용자 단건 조회
    putUserIdPassword: (userId: number) => `${END_POINT.settingController.users}/${userId}/password`, // 사용자 비밀번호 변경
    putUserIdPenalty: (userId: number) => `${END_POINT.settingController.users}/${userId}/penalty`, // 사용자 페널티 변경
    putUserIdNotification: (userId: number) => `${END_POINT.settingController.users}/${userId}/notification`, // 사용자 알림 변경

    authorities: '/settings/authorities', // 권한관리 엔드포인트의 기본 경로

    /** GET **/
    getAuthorities: () => `${END_POINT.settingController.authorities}`, // 권한관리 조회
    postGroupIdMenus: (groupId: number) => `${END_POINT.settingController.authorities}/groups/${groupId}/menus`, // 그룹메뉴 추가
    postGroupIdUser: (groupId: number) => `${END_POINT.settingController.authorities}/groups/${groupId}/users`, // 그룹 사용자 추가
    deleteGroupIdUser: (groupId: number) => `${END_POINT.settingController.authorities}/groups/${groupId}/users`, // 그룹 사용자 삭제
    deleteGroupIdMenuId: (groupId: number, menuId: number) => `${END_POINT.settingController.authorities}/groups/${groupId}/menus/${menuId}` // 그룹메뉴 삭제
  },
  // 내방신청
  visitRequestController: {
    main: '/visit-requests', // 메뉴 엔드포인트의 기본 경로
    /** GET **/
    getVisitRequestBasic: () => `${END_POINT.visitRequestController.main}/basic`, // 내방신청 기초정보 조회
    getVisitRequestManagers: () => `${END_POINT.visitRequestController.main}/managers`, // 담당자 조회
    getVisitRequestId: (id: number) => `${END_POINT.visitRequestController.main}/${id}`, // 내방신청 조회 (id)
    getVisitRequestHistory: () => `${END_POINT.visitRequestController.main}`, // 내방신청 전체 조회
    getVisitRequestActionPublic: (action: string, token: string, user: number) => `${END_POINT.visitRequestController.main}/${action}?t=${token}&u=${user}`, // 오픈된 승인/반려
    getSendApprovedVisitorList: () => `${END_POINT.visitRequestController.main}/approved-visitors/send-mail`, // 승인 목록 메일 전송
    /** POST **/
    postVisitRequest: () => `${END_POINT.visitRequestController.main}`, // 내방신청 저장
    /** PUT **/
    putVisitRequestId: (id: number) => `${END_POINT.visitRequestController.main}/${id}`, // 내방신청 변경 (id)
    putVisitRequestApproveId: (id: number) => `${END_POINT.visitRequestController.main}/${id}/approve`, // 내방신청 승인 (id)
    putVisitRequestCancelId: (id: number) => `${END_POINT.visitRequestController.main}/${id}/cancel`, // 내방신청 취소 (id)
    putVisitRequestRejectedId: (id: number) => `${END_POINT.visitRequestController.main}/${id}/reject` // 내방신청 반려 (id)
  },
  // 방문자들
  visitorsController: {
    main: '/visitors', // 방문자들 엔드포인트의 기본 경로
    /** GET **/
    getVisitorsStatus: (date: string, businessPlaceId: string, name: string, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/status?visitDate=${date}&businessPlaceId=${businessPlaceId}&name=${name}&securityCardNumber=${securityCardNumber}`, // 내방신청 현황
    getVisitorIdSecurityCardNumberHistory: (visitorId: number, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/${visitorId}/security-cards/${securityCardNumber}/history`, //출입보안카드 내역 조회
    /** POST **/
    postVisitorIdSecurityCardNumberDamage: (visitorId: number, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/${visitorId}/security-cards/${securityCardNumber}/damage`, //출입보안카드 파손
    postVisitorIdSecurityCardNumberIssue: (visitorId: number, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/${visitorId}/security-cards/${securityCardNumber}/issue`, //출입보안카드 지급
    postVisitorIdSecurityCardNumberLose: (visitorId: number, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/${visitorId}/security-cards/${securityCardNumber}/lose`, //출입보안카드 분실
    postVisitorIdSecurityCardNumberLoseCancel: (visitorId: number, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/${visitorId}/security-cards/${securityCardNumber}/lose-cancel`, //출입보안카드 분실취소
    postVisitorIdSecurityCardNumberDamageCancel: (visitorId: number, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/${visitorId}/security-cards/${securityCardNumber}/damage-cancel`, //출입보안카드 파손취소
    postVisitorIdSecurityCardNumberReturn: (visitorId: number, securityCardNumber: string) =>
      `${END_POINT.visitorsController.main}/${visitorId}/security-cards/${securityCardNumber}/return` //출입보안카드 회수
  },
  // 코드인증
  noticesController: {
    main: '/notices', // 공지사항 엔드포인트의 기본 경로
    /** GET **/
    getNotices: () => `${END_POINT.noticesController.main}`, // 공지사항 전체 조회
    getNoticesId: (id: number) => `${END_POINT.noticesController.main}/${id}`, // 공지사항 단일 조회
    /** POST **/
    postNoticesCreate: () => `${END_POINT.noticesController.main}/create`, // 공지사항 등록
    /** DELETE **/
    deleteNoticesId: (id: number) => `${END_POINT.noticesController.main}/delete/${id}`, // 공지사항 삭제
    /** GET **/
    getNoticesPopup: () => `${END_POINT.noticesController.main}/pop-up`, // 팝업 공지사항 전체 조회
    /** PUT **/
    putNoticesUpdateId: (id: number) => `${END_POINT.noticesController.main}/update/${id}` // 공지사항 수정
  },

  // 이력관리
  logsController: {
    main: '/logs', // 이력관리 엔드포인트의 기본 경로
    /** GET **/
    getLogs: () => `${END_POINT.logsController.main}`, // 로그 전체 조회
    getLogsId: (id: number) => `${END_POINT.logsController.main}/${id}`, // 로그 단일 조회
    getLogsLogin: () => `${END_POINT.logsController.main}/login`, // 로그 조회 - 로그인
    getLogsSettings: () => `${END_POINT.logsController.main}/settings` // 로그 조회 - 환경설정
  }
};
